import { get_depret_from_result, parseToLdsDate } from "./LDSHelpers";
import { orgTourDealSnapshotStorageKey } from "./organizedTourRoutes";

function pickDealRoot(raw) {
  if (!raw || typeof raw !== "object") return null;
  return raw.fullDeal && typeof raw.fullDeal === "object" ? raw.fullDeal : raw;
}

export function readOrganizedTourDealId(deal) {
  const root = pickDealRoot(deal);
  return String(
    root?.dealId ?? root?.id ?? deal?.dealId ?? deal?.ID ?? ""
  ).trim();
}

export function findOrganizedTourDealInSearchResults(searchResults, dealId) {
  const want = String(dealId ?? "").trim();
  if (!want || !Array.isArray(searchResults)) return null;
  for (const row of searchResults) {
    const root = pickDealRoot(row);
    const id = readOrganizedTourDealId(row);
    if (id === want) {
      return pickDealRoot(row) || row;
    }
    const lds = root?.ldsDealId ?? row?.ldsDealId;
    if (lds != null && String(lds) === want) return pickDealRoot(row) || row;
  }
  return null;
}

export function readOrganizedTourDealSnapshot(dealId) {
  const key = orgTourDealSnapshotStorageKey(dealId);
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (readOrganizedTourDealId(parsed) === String(dealId).trim()) {
      return pickDealRoot(parsed) || parsed;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function writeOrganizedTourDealSnapshot(deal) {
  const id = readOrganizedTourDealId(deal);
  if (!id) return;
  try {
    sessionStorage.setItem(
      orgTourDealSnapshotStorageKey(id),
      JSON.stringify(deal)
    );
  } catch {
    /* ignore quota */
  }
}

export function buildGetLdsOrderByIdPayload(deal, roomInfo, searchDates) {
  const root = pickDealRoot(deal) || deal;
  const ldsDealId =
    root?.ldsDealId ?? root?.dealId ?? root?.id ?? searchDates?.fallbackDealId;
  let { depDate, retDate } = root ? get_depret_from_result(root) : { depDate: "", retDate: "" };
  if (!depDate && searchDates?.depDate) {
    depDate =
      parseToLdsDate(searchDates.depDate) || String(searchDates.depDate);
  }
  if (!retDate && searchDates?.retDate) {
    retDate =
      parseToLdsDate(searchDates.retDate) || String(searchDates.retDate);
  }
  const rooms = roomInfo?.rooms || roomInfo || [];
  let totalAdults = 0;
  let totalKids = 0;
  let totalInfant = 0;
  if (Array.isArray(rooms)) {
    for (const r of rooms) {
      totalAdults += Number(r?.adults ?? r?.numOfAdults ?? 0);
      totalKids += Number(r?.children ?? r?.numOfChildren ?? 0);
      totalInfant += Number(r?.infants ?? r?.numOfInfants ?? 0);
    }
  }
  if (!totalAdults && !totalKids && !totalInfant) {
    totalAdults = 2;
  }
  return {
    ldsDealId,
    depDate,
    retDate,
    numOfAdults: totalAdults,
    numOfChildren: totalKids,
    numOfInfants: totalInfant,
    deal_type: "OrganizedTour",
  };
}
